import {BehaviorSubject} from 'rxjs';

export const _appOverlay$ = new BehaviorSubject<boolean>(false);
export const setAppOverlay = (show: boolean) => _appOverlay$.next(show);
export const resetAppOverlay = () => _appOverlay$.next(false);

export const isShowingAppOverlay$ = _appOverlay$.asObservable().shareReplay(1);
